import { useCartApi } from './useCartApi';
import { useCartGetters } from './useCartGetters';
import { useCartHelpers } from './useCartHelpers';

import type { UseCart } from './types';
export function useCart(): UseCart {
  return {
    ...useCartApi(),
    ...useCartGetters(),
    ...useCartHelpers(),
  };
}
